import { render, staticRenderFns } from "./BillPrediction.vue?vue&type=template&id=4253c4d4"
import script from "./BillPrediction.vue?vue&type=script&lang=js"
export * from "./BillPrediction.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports